"use strict";
/// <reference path="irep.js"/>

IREP.inbox = (function () {
    var UserInbox, MessageDetail, MessageDetailTemplate, AllowReply, Message, messageId, MessageExpandedTemplate

    var init = function (options) {
        UserInbox = options.UserInbox;
        MessageDetail = options.MessageDetail;
        MessageDetailTemplate = Handlebars.compile($("#message-details-template").html());
        MessageExpandedTemplate = Handlebars.compile($("#message-expanded-template").html());
        AllowReply = options.AllowReply;
        Message = options.Message;

        Handlebars.registerHelper("setbackgroundcolor", function (index) {
            if (index % 2 == 0)
                return "sm-even";
            else
                return "sm-odd";
        });

        Handlebars.registerHelper("setfontcolor", function (from) {
            if (from == "Intel Support")
                return "blue";
            else
                return "green";
        });

        $(".message-row").click(function () {
            messageId = $(this).data("messageid");
            
            $("#divMessageExpanded" + messageId).empty();
                
            if ($("#divArrow" + messageId).hasClass('sm-arrow-right')) //check arrow position before fetching message thread
            {
                ExpandMessageThread();
            }
            else
            {
                $("#divArrow" + messageId).removeClass("sm-arrow-down").addClass("sm-arrow-right");
            }
        })
  

        $(".messagethread-expanded").click(function () {
            messageId = $(this).data("messageid");
            $(UserInbox).css("display", "none");

            $("#divMessageDetail").empty();
            var data = { DeliveryCode: messageId }
            IREP.callApi("messages/get", "GET", data)
                .done(function (data) {
                    if (data.messages != null && data.messages.length !== 0) {
                        $(MessageDetail).css("display", "block");
                        var html = MessageDetailTemplate(data.messages);
                        $("#message-details-header").html(data.messages[0].messageSubject.toUpperCase());
                        $("#divMessageDetail").html(html);

                        if (data.messages[0].allowReplyLastMessage) {
                            $(AllowReply).removeAttr('checked');
                            $("#message-details-reply").show();
                            $("#aSend").show();
                        }
                        else {
                            $("#message-details-reply").hide();
                            $("#aSend").hide();
                        }
                    }
                    else {
                        $(MessageResults).html();
                    }
                })
                .fail(function () {
                    $("#MessageResults").html("There was an error getting the message details.");
                })

        })

        $("#aBack").click(function () {
            if ($("#MessageResults").html() == "Message sent successfully.") {
                ExpandMessageThread();//get new sent message
            }
            BackToInbox();
        })

        $("#aSend").click(function () {
            if ($.trim($(Message).val()) != "") {
                var data = { DeliveryCode: messageId, Message: $.trim ($(Message).val()), AllowReply: $(AllowReply).is(':checked') }
                IREP.callApi("messages/send", "POST", data)
                    .done(function () {
                        $(Message).val('');
                        $("#MessageResults").html("Message sent successfully.");
                    })
                    .fail(function () {
                        $("#MessageResults").html("There was an error sending your message.");
                    })
            }
        })
    }

    var ExpandMessageThread = function () {
        IREP.leaderboard.block($("#divMessage" + messageId));
        var data = { DeliveryCode: messageId }
        IREP.callApi("messages/get", "GET", data)
            .done(function (data) {
                if (data.messages != null && data.messages.length !== 0) {

                    var html = MessageExpandedTemplate(data.messages);
                    $("#divMessageExpanded" + messageId).html(html);

                    if (data.messages[0].allowReplyLastMessage) {
                        $(AllowReply).removeAttr('checked');
                    }
                    $("#divArrow" + messageId).removeClass("sm-arrow-right").addClass("sm-arrow-down");
                    $("#divArrow" + messageId).removeClass("sm-arrow-right").addClass("sm-arrow-down");
                    $("#divMessage" + messageId).unblock();
                }
                else {
                }
            })
            .fail(function () {
                $("#MessageResults").html("There was an issue opening the message thread.");
            })
    }
    var BackToInbox = function () {
        $(UserInbox).css("display", "block");
        $(MessageDetail).css("display", "none");
        $("#MessageResults").empty();
    }
    return {
        init: init
    };
})();